import type { TextFieldProps as InternalTextFieldProps } from './TextField.tsx';
import TextField from './TextField.tsx';
import type { TextFieldFormikProps } from './TextFieldFormik.tsx';
import TextFieldFormik from './TextFieldFormik.tsx';

export type TextFieldProps = {
  useFormik?: boolean | null;
} & (InternalTextFieldProps | TextFieldFormikProps);

// TODO We should deprecate this
export default ({ useFormik = true, ...props }: TextFieldProps) =>
  useFormik ? <TextFieldFormik {...props} /> : <TextField {...props} />;
